// extracted by mini-css-extract-plugin
module.exports = {"container":"tagsSearch_container__APDrP","close":"tagsSearch_close__1uuyx"};